import { css } from 'lit';

export const style = css`
  .review-card {
    background-color: #fff;
    border: 1px solid #d4d4d4;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    overflow: hidden;
    width: 100%;
  }

  .review-card.placeholder {
    background-color: #f4f4f4;
  }

  .review-card-content {
    display: flex;
    flex-direction: column;
  }

  .skeleton-content {
    padding: 1rem;
  }

  .truncate-display {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  @media only screen and (max-width: 744px) {
    .skeleton-content {
      margin-right: 2rem;
    }
  }

  .card-header {
    align-items: center;
    display: flex;
    justify-content: space-between;
    padding: 0.75rem 1rem 0 1rem;
  }

  .card-alert {
    padding: 0.75rem 1rem 0 1rem;
  }

  .card-content {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    overflow: auto;
    overflow-wrap: break-word;
    padding: 0.5rem 1rem 1rem 3.5rem;
  }

  .editing {
    padding-inline: 1rem;
  }

  .no-indent {
    padding-inline: 0;
  }

  .hidden {
    visibility: hidden;
  }

  .inactive {
    opacity: 0.6;
  }

  .icon-and-title {
    align-items: center;
    display: flex;
    gap: 1em;
  }

  .edit-button {
    align-items: center;
    background: none;
    border: none;
    display: flex;
    padding: 0;
  }

  .button-row {
    display: flex;
    flex-direction: row-reverse;
  }
`;
